import React from 'react';
import AdProvider from './AdProvider';

const advertize = AdComponent => {
  return class AdvertisedComponent extends React.Component {
    static contextTypes = AdProvider.childContextTypes;

    render() {
      const adContext = this.context.ad;

      if (!adContext) {
        throw new Error(
          `Ad components need to have an AdProvider context, please wrap your Ad placements with an AdProvider.`
        );
      }

      return <AdComponent {...this.props} {...adContext} />;
    }
  };
};

export default advertize;
